// ControlVerticalSeparatorFactory.js
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import VerticalSeparatorControlView from 'advanced-visuals/VerticalSeparatorControlView.js';

//=============================================================================
//
// Creates a vertical separator control, given a factoryService
// parameter key and a layout postion. The factory key defines the initial
// rectangle of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 8, 2015 
//
//=============================================================================
class ControlVerticalSeparatorFactory extends BaseVisualControlFactory {
	constructor () {
		super();
	}

	createView( factoryKey, pos ) {
  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
		attributes.silent = false;
		attributes.width=  '~seperatorSize';
		attributes.lineColor = '~seperatorColor';
        attributes.resizePadding = 2;
		attributes.minWidth = 1;
		attributes.minHeight = 10;

        return new VerticalSeparatorControlView( { 
        	model: new ControlModel( attributes ), 
        	el: $(constants.FORM_ID),  
			pos: pos, 
			factoryKey: factoryKey, 
			id: attributes.id } );
	}

}

const controlVerticalSeparatorFactory = new ControlVerticalSeparatorFactory();
export default controlVerticalSeparatorFactory;
